import { useFormContext, type ControllerRenderProps } from "react-hook-form"

import { LenderCard } from "@/components/lender-match/LenderCard"
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form"

import type { Product } from "@boundless/bl-api-client/common/models/Product"
import type { LenderProfile } from "@boundless/bl-api-client/customer/models"

interface LenderMatchFormProps {
  lenders?: LenderProfile[]
  products?: Product[]
}

export function LenderMatchForm({ lenders, products }: LenderMatchFormProps) {
  const form = useFormContext()

  return (
    <FormField
      control={form.control}
      name="lender"
      render={({ field }: { field: ControllerRenderProps }) => (
        <FormItem>
          <FormControl>
            <div className="space-y-4">
              {lenders?.map((lender) => (
                <LenderCard
                  key={lender.id}
                  lender={lender}
                  isSelected={field.value === lender.id}
                  onSelect={(id) => field.onChange(id)}
                  products={products}
                />
              ))}
            </div>
          </FormControl>
          <FormMessage className="form-error" />
        </FormItem>
      )}
    />
  )
}
